export default __webpack_public_path__ + "static/media/13_HydrogenLane.09e72a73.jpeg";